<template>
  <div v-if="userRole !== 'guest'">
    <button type="button" class="btn btnFull btnPrimary" @click="onSave">{{locale.save}}</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SetCategory',
  props: [
    'locale'
  ],
  computed: {
    ...mapGetters({
      categoryList: 'category/list'
    }),
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    }
  },
  methods: {
    createPath () {
      const list = this._.cloneDeep(this.categoryList)
      const setPath = function (arr, parPath) {
        arr.forEach(function (x) {
          x.path = []
          x.path = parPath.slice()
          x.path.push(x.text)
          if (x.children && x.children.length) {
            setPath(x.children, x.path)
          }
        })
      }
      setPath(list, [])
      return list
    },
    validateOnSave () {
      console.log('카테고리 저장시 체크할 것들')
      return true
    },
    onSave () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        const categoryData = this.createPath()
        this.$store.commit('onLoading', true)
        this.$store.dispatch('category/setCategory', categoryData)
          .then(res => {
            alert(this.locale.complete_save)
            this.$store.dispatch('category/getCategory')
            this.$store.commit('onLoading', false)
          })
      }
    }
  }
}
</script>
